import { get, writable } from "svelte/store";

import LoadState from "../Enums/LoadState";
import IconMode from "../Map/Enums/IconMode";
import AlertType from "./AlertType";

import AlertsActions from "./AlertsActions";
import AlertsHelpers from "./AlertsHelpers";

import Filters from "../Filters/Filters";
import AlertFilterProperties from "./AlertFilterProperties";

import VesselGroup from "../Models/VesselGroup";

const _filterType = (visible = true, exists = false) => {
	const obj = {
		visible: writable(visible),
		exists: writable(exists),
		subcategories: writable([]),
		lastUpdated: writable(0)
	};
	obj.visible.subscribe((vis) => {
		const subs = get(obj.subcategories);
		// console.log("setting visible", vis, subs.length);
		for (let i = 0; i < subs.length; i++) {
			// subs[i].visible.set(vis);
			subs[i].exists.set(vis);
		}
		obj.subcategories.set(subs);
		obj.lastUpdated.set(Date.now());
	});
	obj.exists.subscribe((exists) => {
		const subs = get(obj.subcategories);
		// console.log("setting exists", exists, subs.length);
		for (let i = 0; i < subs.length; i++) {
			subs[i].exists.set(exists);
		}
		obj.subcategories.set(subs);
		obj.lastUpdated.set(Date.now());
	});
	/**
	 * Used to determine if a vessel should use the colour for this AlertType
	 * @returns
	 */
	obj.isVisible = () => {
		const countWithName = obj.countCategoriesWithName();
		if (countWithName > 1) {
			let vis = false;
			const subcategories = get(obj.subcategories);
			for (let i = 0; i < subcategories.length; i++) {
				if (get(subcategories[i].visible)) {
					// return true;
					vis = true;
				}
			}
			if (!get(obj.visible)) {
				vis = false;
			}
			return vis;
		}
		else if (countWithName === 1) {
			const subcategories = get(obj.subcategories);
			if (get(subcategories[0].visible)) {
				return true;
			}
			return false;
		}
		if (get(obj.visible)) {
			return true;
		}
		return false;
	};
	obj.countCategoriesWithName = () => {
		const subcategories = get(obj.subcategories);
		let count = 0;
		for (let i = 0; i < subcategories.length; i++) {
			if (subcategories[i].name !== AlertType.DEFAULT_CATEGORY_NAME && subcategories[i].name !== "") {
				count++;
			}
		}
		// console.log("countCategoriesWithName", count);
		return count;
	};

	return obj;
};
const _filterTypeSubcategory = (name, visible = true, exists = false) => {
	const obj = {
		name: name,
		exists: writable(exists),
		visible: writable(visible)
	};
	return obj;
};

const AlertsStore = {
	meta: {
		loadState: writable(LoadState.INIT), // Load state on initial load
		updateState: writable(LoadState.INIT), // Load state on refreshing data
		lastUpdated: writable(new Date(0)),
		nowTimeOverride: writable(undefined),
		hasHistoricData: writable(false),
		mapInitted: writable(false),
		defaultKeyInitted: writable(false)
	},
	vesselGroup: new VesselGroup(),
	// mode: "select", // TODO: "measure" mode
	filters: {
		// The store of whether alert types exist or are visible
		// TODO: refactor into initialisation loop
		alertTypes: {
			[AlertType.NONE]: _filterType(),
			[AlertType.ABO]: _filterType(),
			[AlertType.CAS]: _filterType(),
			[AlertType.ERI]: _filterType(),
			[AlertType.LRI]: _filterType(),
			[AlertType.PCS]: _filterType(),
			[AlertType.LPO]: _filterType(),
			[AlertType.O7D]: _filterType(),
			[AlertType.O1D]: _filterType(),
			[AlertType.O2D]: _filterType(),
			[AlertType.O22H]: _filterType(),
			[AlertType.EEZ]: _filterType(),
			[AlertType.LEZ]: _filterType(),
			[AlertType.ETW]: _filterType(),
			[AlertType.LTW]: _filterType(),
			[AlertType.MYF]: _filterType(),
			[AlertType.STS]: _filterType(),
			[AlertType.NBY]: _filterType(),
			[AlertType.RIM]: _filterType(),
			[AlertType.DEC]: _filterType(),
			[AlertType.COF]: _filterType()
		},
		advanced: new Filters(AlertFilterProperties),
		// TODO: rename this to something more clear, it only filters the alertlist
		//  - should it be grouped seperately as it's for a component; not application level?
		//  - also why not use an array rather than a string?
		filterString: writable(""),
		lastUpdated: writable(new Date(0))
	},
	// selection: {
	// THIS IS UPDATED AUTOMATICALLY, DO NOT SET DIRECTLY
	// TODO: is there an arcitectural way to allow this to be updated by Vessel functiuon but nothing else?
	// vesselImos: writable([])
	// },
	iconMode: writable(IconMode.ALERT),
	_localCaches: {
		mapReady: false,
		updateMapSourcesRequestRejected: false
	},
	events: { onAlertTypeToggle: writable(null) },

	actions: { ...AlertsActions },
	helpers: { ...AlertsHelpers },
	generators: {
		filterType: _filterType,
		filterTypeSubcategory: _filterTypeSubcategory
	}
};

export default AlertsStore;
